import { assert_string_not_empty, assert_type_number } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__ml_asset_lora_tag_frequency extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.ML_ASSET_LORA_TAG_FREQUENCY;

  /*
   * STATIC METHODS
   */

  static map_by_word(items: DTO__ml_asset_lora_tag_frequency[]) {
    let out = new MAP__serializable<string, DTO__ml_asset_lora_tag_frequency>();

    for (let item of items) {
      out.set(item.word, item);
    }

    return out;
  }

  static sort_by_frequency(item_a: DTO__ml_asset_lora_tag_frequency, item_b: DTO__ml_asset_lora_tag_frequency) {
    return item_b.frequency - item_a.frequency;
  }

  static filter_by_largest_gap(items: DTO__ml_asset_lora_tag_frequency[]) {
    // 1. Clone to avoid mutating the original array
    const items_sorted = [...items];

    items_sorted.sort(DTO__ml_asset_lora_tag_frequency.sort_by_frequency);

    if (items_sorted.length <= 1) return items_sorted;

    let [largest_gap, split_index] = [-1, 0]; // Start below 0 to catch the first gap even if it's 0

    // 3. Find the largest drop-off
    for (let i = 0; i < items_sorted.length - 1; i++) {
      const gap = items_sorted[i].frequency - items_sorted[i + 1].frequency;

      if (gap > largest_gap) {
        largest_gap = gap;
        split_index = i;
      }
    }

    // 4. Return everything up to and including the element before the giant drop
    return items_sorted.slice(0, split_index + 1);
  }

  /*
   * FIELDS
   */
  word!: string;
  frequency!: number;
  frequency_percent!: number;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_not_empty(this.word);
    assert_type_number(this.frequency);
    assert_type_number(this.frequency_percent);
  }
}
